export const CUBIC_METER_IN_CENTIMETERS = 100 * 100 * 100;
export const UNIT_VOLUME_IN_CENTIMETERS = 120 * 200 * 1;
export const CUBIC_METERS_IN_UNIT = UNIT_VOLUME_IN_CENTIMETERS / CUBIC_METER_IN_CENTIMETERS;